import { render } from "./ProfesionalesModificacion.vue?vue&type=template&id=dec73744&ts=true"
import script from "./ProfesionalesModificacion.vue?vue&type=script&lang=ts"
export * from "./ProfesionalesModificacion.vue?vue&type=script&lang=ts"

import "./ProfesionalesModificacion.vue?vue&type=style&index=0&id=dec73744&lang=scss"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__